<template>
    <label
        :class="marginClass"
        class="mb-[8px] leading-tight font-oceanside font-semibold"
    >
        <span
            v-if="isRequired"
            class="text-red"
        >
            *
        </span>

        {{ labelText }}:
    </label>
</template>

<script>
    export default {
        props: {
            labelText: {
                type: String,
                required: true,
            },

            labelPosition: {
                type: String,
                default: 'top',
            },

            isRequired: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            marginClass() {
                return this.labelPosition === 'left' ? 'mr-1' : 'mb-1';
            },
        },
    };
</script>
